import React from 'react';
import HeaderOne from "./header/HeaderOne";
import FooterThree from "./footer/FooterThree";
import Copyright from "./footer/Copyright";

const Layout = ({children}) => {
    return (
        <>
            <main className="page-wrapper">
                <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-not-transparent" />
                {children}
                <FooterThree />
            </main>
        </>
    )
}
export default Layout;
